import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';


  
  export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
      setUsers:(state, action) => {
        state.usersData = action.payload
      },
      deleteUser:(state, action) => {
        state.usersData = state.usersData.filter(d => d.email !== action.payload)
      },
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const { setUsers,deleteUser } = usersSlice.actions
  
  export default usersSlice.reducer